/**
 * Copyright (c) Matthieu POIGNANT
 * matthieu@highlight.pro
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 */
import Interface from '../../interface';
import Theme from "../../Theme";

const ConfirmStyled = Interface.styled('div')`
  position: absolute;
  width: 100%;
  height: 100%;
  background: ${(props) => props?.theme?.palette?.background ?? '#ffffff'};
  display: none;
  flex-direction: column;
  justify-content: center;
  gap: 16px;
`;
ConfirmStyled.defaultProps = {
    theme: Theme,
};

const ConfirmText = Interface.styled('div')`
  text-align: center;
  font-size: 2em;
`;

const ConfirmButtons = Interface.styled('div')`
  display: flex;
  justify-content: center;
  gap: 16px;
  
  & > button {
    border: none;
    outline: none;
    cursor: pointer;
    font-size: 16px;
    background-repeat:no-repeat;
    background-size: 16px;
    background-position:8px;
    padding: 8px;
    padding-left: 32px;
    margin-top: 8px;
  }
`;
ConfirmButtons.defaultProps = {
    theme: Theme,
};


const ConfirmYesButton = Interface.styled('button')`
  color: ${(props) => props?.theme?.palette?.button?.confirm?.yes?.color ?? '#ffffff'};
  background: ${(props) => props?.theme?.palette?.button?.confirm?.yes?.background ?? 'green'};
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="${(props) => encodeURIComponent(props?.theme?.palette?.button?.confirm?.yes?.color ?? '#fffff')}"><g stroke-width="0"/><g stroke-linecap="round" stroke-linejoin="round"/><path d="M14.351 2.285a.622.622 0 0 0-.88 0l-7.32 7.318-3.77-3.796a.621.621 0 0 0-.879 0L.181 7.127a.625.625 0 0 0 0 .88l5.526 5.563a.626.626 0 0 0 .88 0l9.084-9.084a.622.622 0 0 0 0-.883l-1.32-1.317z"/></svg>');
`;
ConfirmYesButton.defaultProps = {
    theme: Theme,
};

const ConfirmNoButton = Interface.styled('button')`
  color: ${(props) => props?.theme?.palette?.button?.confirm?.no?.color ?? '#ffffff'};
  background: ${(props) => props?.theme?.palette?.button?.confirm?.no?.background ?? 'red'};
  background-image: url('data:image/svg+xml,<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="${(props) => encodeURIComponent(props?.theme?.palette?.button?.confirm?.no?.color ?? '#fffff')}"><g stroke-width="0"/><g stroke-linecap="round" stroke-linejoin="round"/><path d="M5.386 4.259c-.572.107-1.415 1.085-1.043 1.458L6.63 8.002l-2.287 2.285c-.458.458.914 1.828 1.372 1.371l2.287-2.285 2.287 2.285c.458.458 1.829-.914 1.372-1.371L9.374 8.002l2.287-2.285c.458-.458-.914-1.828-1.372-1.371L8.002 6.631 5.715 4.346c-.086-.086-.197-.112-.329-.086zM8 .5C3.857.5.5 3.858.5 8s3.357 7.5 7.5 7.5 7.5-3.358 7.5-7.5S12.143.5 8 .5zm0 1.875a5.624 5.624 0 1 1 0 11.25 5.624 5.624 0 1 1 0-11.25z"/></svg>');
`;
ConfirmNoButton.defaultProps = {
    theme: Theme,
};

const e = Interface.createElement;

const Confirm = ({handlePrevClick, handleYesClick, handleNoClick}) =>
    e(ConfirmStyled, {
            className: `ziiircom-messenger-confirm`,
            onClick: handlePrevClick,
        },
        e(ConfirmText, {
            className: `ziiircom-messenger-confirm-text`,
        }, 'Confirm?'),
        e(ConfirmButtons, {
                className: `ziiircom-messenger-confirm-buttons`,
            },
            e(ConfirmYesButton, {
                className: `ziiircom-messenger-confirm-button-yes`,
                onClick: handleYesClick,
            }, 'Yes'),
            e(ConfirmNoButton, {
                className: `ziiircom-messenger-confirm-button-no`,
                onClick: handleNoClick,
            }, 'No')
        ),
    )
;

export default Confirm;
